module.exports = __webpack_public_path__ + "static/media/Misto.2ffc0819.woff";